var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-897 -299)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0H1440V1024H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 668,
    height: 184,
    x: 601.5,
    y: 170.5,
    stroke: "#D9D9D9",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 303,
    height: 44,
    x: 622.5,
    y: 280.5,
    stroke: "#3E4A56",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8D8E97",
    d: "M903.371 299.256l-6.12 6.23c-.335.362-.335.917 0 1.258.336.341.88.341 1.237 0l5.512-5.61 5.512 5.61c.335.341.901.341 1.237 0 .335-.341.335-.896 0-1.259l-6.141-6.229c-.336-.341-.88-.341-1.237 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowUp);
export default __webpack_public_path__ + "static/media/keyboard_arrow_up.575da43d09efc7b59b514194d0cdb865.svg";
export { ForwardRef as ReactComponent };